import { createStore as reduxCreateStore } from "redux"

const reducer = (state, action) => {
	// console.info("--------------------")
	// console.info("\x1b[36m", "prev state -> ", state)
	// console.info("\x1b[36m", "action", action)
	if (action.type === `INCREMENT`) {
		state = Object.assign({}, state, {
			count: state.count + action.index,
		})
		// return state
	}
	if (action.type === `FETCHED_PRODUCT_LIST`) {
		const { list } = action
		let listItemById = {}
		let infoListItemById = {}
		let wholeMasalas = []
		let blendedMasalas = []
		let specialities = []
		let pujaMaterials = []
		list.map((item) => {
			infoListItemById = {
				...infoListItemById,
				[item.info_id]: item
			}
			if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
				listItemById[item.id] = []
			}
			if (item.ingredients === "1" && item.type_id === "Spices") {
				wholeMasalas.push(item)
			} else if (item.type_id === "Spices") {
				blendedMasalas.push(item)
			}
			if (item.type_id === "Misc") {
				specialities.push(item)
			} else if (item.type_id === "Dhoop") {
				pujaMaterials.push(item)
			}
			listItemById[item.id].push(item)
		})
		state = Object.assign({}, state, {
			products:  {
				...state.products,
				list,
				listItemById,
				infoListItemById,
				wholeMasalas,
				blendedMasalas,
				specialities,
				pujaMaterials,
				meta: {
					isFetching: false
				}
			}
		})
		// return state
	}
	if (action.type === `ADD_TO_CART`) {
		const { list } = action
		state = Object.assign({}, state, {
			products:  {
				...state.products,
				cart: list,
				cartChange: !state.products.isCartChange
			}
		})
	}
	// console.info("\x1b[36m", "next state -> ", state)
	// console.info("--------------------")
	// state = { ...stateObj }
	return state
}

const initialState = { count: 0, products: { list: [], meta: { isFetching: true }, cart: {}, cartChange: false } }

const createStore = () => reduxCreateStore(reducer, initialState)
export default createStore



// WEBPACK FOOTER //
// ./src/state/createStore.js